import React, { Component } from 'react';
export default class About extends Component {
   render() {
      let resumeData = this.props.resumeData;
      return (
         <section id="about">
            <div className="row">

               <div className="three columns">

                  <img className="profile-pic" src="images/miniPhoto.jpg" alt="" />

               </div>

               <div className="nine columns main-col">

                  <h2>About Me</h2>

                  {
                     resumeData.aboutme.split('|').map((element, index) => { return <p key={index}>{element.trim()}</p>; })
                  }

                  <div className="row">

                     <div className="columns contact-details">

                        <h2>Contact Details</h2>
                        <p className="address">
                           <span>{resumeData.name} {resumeData.emailid}</span>
                           <br></br>
                           <span>
                              {resumeData.address}
                           </span>

                           <span>{resumeData.website}</span>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}
